var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMotorCycleIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 15,
    viewBox: "0 0 23 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.1784 1L13.2233 1.96481C13.5949 2.34439 13.931 2.75718 14.2274 3.19801C15.0673 4.45204 15.6365 5.8981 15.4976 7.42977C15.3866 8.65371 14.5051 10.0142 13.2256 10.2317C11.798 10.4746 10.6342 9.16967 10.2941 7.90408C10.2903 7.56039 10.2245 7.22022 10.0998 6.89993C9.92324 6.39356 9.58397 5.95992 9.13496 5.66673C8.78142 5.47223 8.38125 5.37859 7.97811 5.39603C6.91844 5.39603 5.69681 5.37983 4.31553 5.39603C3.17607 6.01889 2.23964 6.95612 1.61776 8.09611C1.34193 8.60665 1.13424 9.15116 1 9.7157L3.86899 10.8725L7.82541 12.4528H16.5781",
    stroke: "#0008C3",
    strokeWidth: 0.78,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M20.4758 8.43988C19.7493 7.42186 18.5022 7.05167 17.313 6.89896C17.2922 6.56579 17.2552 6.21873 17.1973 5.8578C16.9308 4.2577 16.3258 2.73294 15.4227 1.38542C15.0455 1.1682 14.622 1.0437 14.1872 1.02217C14.0689 1.01753 13.9508 1.03653 13.8399 1.07806C13.729 1.11959 13.6275 1.18281 13.5414 1.26403C13.4552 1.34524 13.3861 1.44283 13.3381 1.55107C13.29 1.65931 13.2641 1.77604 13.2617 1.89443",
    stroke: "#0008C3",
    strokeWidth: 0.78,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M4.94636 3.54297H8.26421C8.40227 3.54297 8.53469 3.59782 8.63231 3.69544C8.72994 3.79307 8.78479 3.92548 8.78479 4.06355V5.39393H4.42578V4.06355C4.42578 3.92548 4.48063 3.79307 4.57826 3.69544C4.67588 3.59782 4.8083 3.54297 4.94636 3.54297Z",
    stroke: "#0008C3",
    strokeWidth: 0.78,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M19.4809 14.5672C21.1574 14.5672 22.5165 13.2082 22.5165 11.5317C22.5165 9.85517 21.1574 8.49609 19.4809 8.49609C17.8044 8.49609 16.4453 9.85517 16.4453 11.5317C16.4453 13.2082 17.8044 14.5672 19.4809 14.5672Z",
    stroke: "#0008C3",
    strokeWidth: 0.78,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M7.93445 12.4532C7.8089 12.8503 7.60305 13.2173 7.32967 13.5315C7.0563 13.8457 6.72124 14.1003 6.34531 14.2796C5.96938 14.4588 5.56062 14.5588 5.1444 14.5734C4.72819 14.588 4.31342 14.5169 3.92586 14.3645C3.53829 14.212 3.18621 13.9815 2.89149 13.6872C2.59677 13.393 2.36569 13.0413 2.21263 12.654C2.05956 12.2666 1.98776 11.852 2.0017 11.4357C2.01564 11.0195 2.11502 10.6106 2.29365 10.2344",
    stroke: "#0008C3",
    strokeWidth: 0.78,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M19.5287 12.6453C20.1357 12.6453 20.6277 12.1532 20.6277 11.5463C20.6277 10.9393 20.1357 10.4473 19.5287 10.4473C18.9217 10.4473 18.4297 10.9393 18.4297 11.5463C18.4297 12.1532 18.9217 12.6453 19.5287 12.6453Z",
    stroke: "#0008C3",
    strokeWidth: 0.78,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M6.05154 11.7419C6.02252 11.9024 5.95817 12.0543 5.86316 12.1868C5.76815 12.3192 5.64486 12.4289 5.50223 12.5078C5.35959 12.5868 5.20119 12.633 5.03849 12.6431C4.87579 12.6533 4.71287 12.6271 4.56153 12.5665C4.4102 12.5059 4.27424 12.4124 4.16352 12.2927C4.05279 12.1731 3.97007 12.0303 3.92134 11.8748C3.87261 11.7192 3.8591 11.5547 3.88179 11.3933C3.90448 11.2319 3.96279 11.0775 4.05251 10.9414",
    stroke: "#0008C3",
    strokeWidth: 0.78,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M9.29494 12.4523V11.0826C9.29438 10.0871 8.94272 9.12374 8.30185 8.36202C7.66098 7.60029 6.77196 7.08903 5.79127 6.91821C4.81057 6.74739 3.80105 6.92796 2.94038 7.42814C2.0797 7.92832 1.42303 8.71605 1.08594 9.6527",
    stroke: "#0008C3",
    strokeWidth: 0.78,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M16.7113 4.33464C17.3285 4.33464 17.8288 3.83431 17.8288 3.21713C17.8288 2.59994 17.3285 2.09961 16.7113 2.09961C16.0941 2.09961 15.5938 2.59994 15.5938 3.21713C15.5938 3.83431 16.0941 4.33464 16.7113 4.33464Z",
    fill: "#F1F4E9",
    stroke: "#0008C3",
    strokeWidth: 0.78,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMotorCycleIcon);
export default __webpack_public_path__ + "static/media/motorCycleIcon.b8e8e3184bf031f27393aaeab3571de5.svg";
export { ForwardRef as ReactComponent };